import DOMPurify from 'dompurify';

const SAFE_URI_PATTERN = /^(?:(?:https?|mailto):|data:image\/[a-z0-9.+-]+;base64,|#|\/)/i;

/** Returns true when a URL is safe for href/src attributes in chat HTML. */
export const isSafeUrl = (url: string | undefined | null): boolean => {
  if (url == null) return false;
  const trimmed = String(url).trim();
  if (!trimmed) return false;
  // Relative paths and fragments are allowed; schemes other than http(s)/mailto/data:image are not.
  if (/^[a-z][a-z0-9+.-]*:/i.test(trimmed) && !SAFE_URI_PATTERN.test(trimmed)) {
    return false;
  }
  return SAFE_URI_PATTERN.test(trimmed) || trimmed.startsWith('/') || trimmed.startsWith('#') || !/^[a-z][a-z0-9+.-]*:/i.test(trimmed);
};

const FORBIDDEN_TAGS = [
  'meta',
  'iframe',
  'object',
  'embed',
  'script',
  'base',
  'link',
  'form',
  'svg',
  'math',
  'applet',
  'frame',
  'frameset',
];

/**
 * Sanitize HTML for safe chat rendering.
 * Strips tags that can trigger outbound requests or script execution (SSRF/XSS vectors).
 */
export const sanitizeHtml = (html: string): string => {
  if (!html) return '';

  return DOMPurify.sanitize(html, {
    USE_PROFILES: { html: true },
    FORBID_TAGS: FORBIDDEN_TAGS,
    FORBID_ATTR: ['http-equiv', 'srcdoc'],
    ALLOWED_URI_REGEXP: SAFE_URI_PATTERN,
    ADD_ATTR: ['target', 'rel'],
  });
};
